export default __webpack_public_path__ + "media/zurb/img/events/wired/raft/raft-2-47eb23d6bd138d56df66b0cdca8f2fd8.png";